const getBackgroundColor = (active) => {
  return active ? "#E14848" : "rgba(164, 161, 170, 0.1)";
};

const getFillColor = (active) => {
  return active ? "white" : "#131118";
};

export const barIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4C2 2.89543 2.89543 2 4 2H8C9.10457 2 10 2.89543 10 4V8C10 9.10457 9.10457 10 8 10H4C2.89543 10 2 9.10457 2 8V4Z"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M14 4C14 2.89543 14.8954 2 16 2H20C21.1046 2 22 2.89543 22 4V8C22 9.10457 21.1046 10 20 10H16C14.8954 10 14 9.10457 14 8V4Z"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2 16C2 14.8954 2.89543 14 4 14H8C9.10457 14 10 14.8954 10 16V20C10 21.1046 9.10457 22 8 22H4C2.89543 22 2 21.1046 2 20V16Z"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M14 16C14 14.8954 14.8954 14 16 14H20C21.1046 14 22 14.8954 22 16V20C22 21.1046 21.1046 22 20 22H16C14.8954 22 14 21.1046 14 20V16Z"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const filterIcon = (
  <svg
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1H15M9 9H15M9 5H21M9 13H21M3 5C1.89543 5 1 4.10457 1 3C1 1.89543 1.89543 1 3 1C4.10457 1 5 1.89543 5 3C5 4.10457 4.10457 5 3 5ZM3 13C1.89543 13 1 12.1046 1 11C1 9.89543 1.89543 9 3 9C4.10457 9 5 9.89543 5 11C5 12.1046 4.10457 13 3 13Z"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const arrowUp = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 14L12 10L7 14"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowDown = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 10L12 14L17 10"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowLeft = (page) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 8L6 12M6 12L10 16M6 12L18 12"
      stroke={page === 1 ? "#A4A2AA" : "#131118"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowRight = (page, paginationLength) => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 9L13 5M13 5L9 1M13 5L1 5"
      stroke={page === paginationLength ? "#A4A2AA" : "#131118"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const viewIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="white" />
    <path
      d="M27.6099 18.211C28.5762 19.2277 28.5762 20.7724 27.6099 21.7892C25.9801 23.504 23.1809 25.8334 20.0013 25.8334C16.8217 25.8334 14.0225 23.504 12.3927 21.7892C11.4264 20.7724 11.4264 19.2277 12.3927 18.211C14.0225 16.4962 16.8217 14.1667 20.0013 14.1667C23.1809 14.1667 25.9801 16.4962 27.6099 18.211Z"
      stroke="#131118"
      strokeWidth="1.5"
    />
    <path
      d="M22.5013 20.0001C22.5013 21.3808 21.382 22.5001 20.0013 22.5001C18.6206 22.5001 17.5013 21.3808 17.5013 20.0001C17.5013 18.6194 18.6206 17.5001 20.0013 17.5001C21.382 17.5001 22.5013 18.6194 22.5013 20.0001Z"
      stroke="#131118"
      strokeWidth="1.5"
    />
  </svg>
);

export const plus = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H11.25V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H12.75V6Z"
      fill="#28303F"
    />
  </svg>
);

export const minus = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.75 12C18.75 12.4142 18.4142 12.75 18 12.75L6 12.75C5.58579 12.75 5.25 12.4142 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25L18 11.25C18.4142 11.25 18.75 11.5858 18.75 12Z"
      fill="#131118"
    />
  </svg>
);

export const trash = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16667 6.66666V15C4.16667 16.8409 5.65905 18.3333 7.5 18.3333H12.5C14.3409 18.3333 15.8333 16.8409 15.8333 15V6.66666M11.6667 9.16666V14.1667M8.33333 9.16666L8.33333 14.1667M13.3333 4.16666L12.1614 2.40882C11.8523 1.94516 11.3319 1.66666 10.7747 1.66666H9.22531C8.66805 1.66666 8.14767 1.94516 7.83856 2.40882L6.66667 4.16666M13.3333 4.16666H6.66667M13.3333 4.16666H17.5M6.66667 4.16666H2.5"
      stroke="#E14848"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const editIcon = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.75 9C17.75 8.58579 17.4142 8.25 17 8.25C16.5858 8.25 16.25 8.58579 16.25 9H17.75ZM9.5 2.25C9.91421 2.25 10.25 1.91421 10.25 1.5C10.25 1.08579 9.91421 0.75 9.5 0.75V2.25ZM7.366 11.9922L7.25994 11.2497L7.366 11.9922ZM6.50783 11.134L5.76536 11.0279L6.50783 11.134ZM7.25873 8.0231L6.7284 7.49277L7.25873 8.0231ZM6.82964 8.88128L7.57211 8.98734L6.82964 8.88128ZM10.4769 11.2413L11.0072 11.7716L10.4769 11.2413ZM9.61872 11.6704L9.72479 12.4128H9.72479L9.61872 11.6704ZM16.5557 3.01706L16.0253 3.54739L16.0253 3.54739L16.5557 3.01706ZM16.5557 5.1625L16.0253 4.63217V4.63217L16.5557 5.1625ZM15.4829 1.94434L16.0133 1.41401V1.41401L15.4829 1.94434ZM13.3375 1.94434L13.8678 2.47467L13.3375 1.94434ZM13.0148 3.01706C13.0148 2.60285 12.679 2.26706 12.2648 2.26706C11.8506 2.26706 11.5148 2.60285 11.5148 3.01706L13.0148 3.01706ZM15.4829 6.98523C15.8972 6.98523 16.2329 6.64944 16.2329 6.23523C16.2329 5.82102 15.8972 5.48523 15.4829 5.48523L15.4829 6.98523ZM16.25 9V13.5H17.75V9H16.25ZM14 15.75H5V17.25H14V15.75ZM2.75 13.5V4.5H1.25V13.5H2.75ZM5 2.25H9.5V0.75H5V2.25ZM2.75 4.5C2.75 3.25736 3.75736 2.25 5 2.25V0.75C2.92893 0.75 1.25 2.42893 1.25 4.5H2.75ZM5 15.75C3.75736 15.75 2.75 14.7426 2.75 13.5H1.25C1.25 15.5711 2.92893 17.25 5 17.25V15.75ZM16.25 13.5C16.25 14.7426 15.2426 15.75 14 15.75V17.25C16.0711 17.25 17.75 15.5711 17.75 13.5H16.25ZM14.9526 2.47467L16.0253 3.54739L17.086 2.48673L16.0133 1.41401L14.9526 2.47467ZM16.0253 4.63217L9.94657 10.7109L11.0072 11.7716L17.086 5.69283L16.0253 4.63217ZM7.78906 8.55343L13.8678 2.47467L12.8072 1.41401L6.7284 7.49277L7.78906 8.55343ZM9.51266 10.9279L7.25994 11.2497L7.47207 12.7346L9.72479 12.4128L9.51266 10.9279ZM7.25029 11.2401L7.57211 8.98734L6.08718 8.77521L5.76536 11.0279L7.25029 11.2401ZM7.25994 11.2497C7.25838 11.2499 7.25737 11.25 7.25684 11.25C7.2563 11.25 7.25606 11.25 7.25606 11.25C7.25604 11.25 7.25612 11.25 7.25626 11.25C7.25638 11.25 7.25647 11.2501 7.25649 11.2501C7.25654 11.2501 7.25487 11.2495 7.2527 11.2473C7.25053 11.2451 7.2499 11.2435 7.24992 11.2435C7.24993 11.2435 7.24995 11.2436 7.24998 11.2437C7.25001 11.2439 7.25002 11.244 7.25002 11.2439C7.25002 11.2439 7.24999 11.2437 7.25 11.2432C7.25001 11.2426 7.25007 11.2416 7.25029 11.2401L5.76536 11.0279C5.62314 12.0235 6.47649 12.8769 7.47207 12.7346L7.25994 11.2497ZM6.7284 7.49277C6.38155 7.83962 6.15655 8.28962 6.08718 8.77521L7.57211 8.98734C7.59558 8.82304 7.6717 8.67079 7.78906 8.55343L6.7284 7.49277ZM9.94657 10.7109C9.82921 10.8283 9.67696 10.9044 9.51266 10.9279L9.72479 12.4128C10.2104 12.3434 10.6604 12.1185 11.0072 11.7716L9.94657 10.7109ZM16.0253 3.54739C16.3249 3.84694 16.3249 4.33262 16.0253 4.63217L17.086 5.69283C17.9713 4.80749 17.9713 3.37207 17.086 2.48673L16.0253 3.54739ZM16.0133 1.41401C15.1279 0.528665 13.6925 0.528664 12.8072 1.41401L13.8678 2.47467C14.1674 2.17511 14.6531 2.17511 14.9526 2.47467L16.0133 1.41401ZM12.2648 3.01706C11.5148 3.01706 11.5148 3.01743 11.5148 3.01781C11.5148 3.01794 11.5148 3.01832 11.5148 3.01858C11.5148 3.0191 11.5148 3.01964 11.5148 3.0202C11.5148 3.02131 11.5148 3.0225 11.5148 3.02375C11.5148 3.02625 11.5148 3.02903 11.5149 3.03207C11.515 3.03817 11.5152 3.04534 11.5154 3.05355C11.516 3.06998 11.5169 3.0906 11.5185 3.11514C11.5218 3.16419 11.5279 3.22907 11.5391 3.3075C11.5615 3.46424 11.6045 3.67621 11.6873 3.92468C11.8539 4.42423 12.1792 5.06485 12.8072 5.69284L13.8678 4.63218C13.4231 4.18744 13.212 3.75533 13.1104 3.45034C13.0591 3.29654 13.0351 3.17329 13.024 3.09537C13.0184 3.05647 13.0161 3.02916 13.0152 3.01536C13.0147 3.00847 13.0146 3.005 13.0146 3.00519C13.0146 3.00529 13.0147 3.0063 13.0147 3.00827C13.0147 3.00925 13.0147 3.01047 13.0148 3.01194C13.0148 3.01267 13.0148 3.01346 13.0148 3.01432C13.0148 3.01474 13.0148 3.01519 13.0148 3.01564C13.0148 3.01587 13.0148 3.01623 13.0148 3.01634C13.0148 3.0167 13.0148 3.01706 12.2648 3.01706ZM12.8072 5.69284C13.4351 6.32082 14.0758 6.64614 14.5753 6.81265C14.8238 6.89548 15.0358 6.93854 15.1925 6.96093C15.2709 6.97214 15.3358 6.9782 15.3849 6.98147C15.4094 6.98311 15.43 6.98405 15.4464 6.98458C15.4547 6.98484 15.4618 6.98501 15.4679 6.9851C15.471 6.98515 15.4737 6.98518 15.4763 6.9852C15.4775 6.98521 15.4787 6.98522 15.4798 6.98522C15.4804 6.98523 15.4809 6.98523 15.4814 6.98523C15.4817 6.98523 15.4821 6.98523 15.4822 6.98523C15.4826 6.98523 15.4829 6.98523 15.4829 6.23523C15.4829 5.48523 15.4833 5.48523 15.4837 5.48523C15.4838 5.48523 15.4841 5.48523 15.4844 5.48523C15.4848 5.48523 15.4853 5.48523 15.4857 5.48524C15.4865 5.48524 15.4873 5.48524 15.4881 5.48525C15.4895 5.48526 15.4907 5.48528 15.4917 5.48529C15.4937 5.48532 15.4947 5.48535 15.4948 5.48536C15.495 5.48536 15.4915 5.48526 15.4846 5.4848C15.4708 5.48388 15.4435 5.48156 15.4046 5.47601C15.3267 5.46487 15.2035 5.44089 15.0497 5.38963C14.7447 5.28796 14.3126 5.07692 13.8678 4.63218L12.8072 5.69284Z"
      fill="#131118"
    />
  </svg>
);

export const creditCard = (
  <svg
    width="27"
    height="22"
    viewBox="0 0 27 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M10.6679 21.3333H16.0012C21.0292 21.3333 23.5439 21.3333 25.1052 19.7707C26.6679 18.2093 26.6679 15.6947 26.6679 10.6667C26.6679 10.0773 26.6652 8.52267 26.6625 8H0.00118519C-0.00148148 8.52267 0.00118519 10.0773 0.00118519 10.6667C0.00118519 15.6947 0.00118526 18.2093 1.56252 19.7707C3.12519 21.3333 5.64119 21.3333 10.6679 21.3333Z"
      fill="black"
    />
    <path
      d="M10.6639 0H16.0106C21.0519 0 23.5732 1.58946e-07 25.1386 1.488C26.2666 2.55867 26.5826 4.10133 26.6706 6.66667V8H0.00390625V6.66667C0.0919062 4.1 0.407906 2.56 1.53591 1.488C3.10124 1.58946e-07 5.62257 0 10.6639 0ZM14.0039 15C13.7387 15 13.4843 15.1054 13.2968 15.2929C13.1093 15.4804 13.0039 15.7348 13.0039 16C13.0039 16.2652 13.1093 16.5196 13.2968 16.7071C13.4843 16.8946 13.7387 17 14.0039 17H16.0039C16.2691 17 16.5235 16.8946 16.711 16.7071C16.8986 16.5196 17.0039 16.2652 17.0039 16C17.0039 15.7348 16.8986 15.4804 16.711 15.2929C16.5235 15.1054 16.2691 15 16.0039 15H14.0039ZM5.33724 15C5.07202 15 4.81767 15.1054 4.63013 15.2929C4.4426 15.4804 4.33724 15.7348 4.33724 16C4.33724 16.2652 4.4426 16.5196 4.63013 16.7071C4.81767 16.8946 5.07202 17 5.33724 17H10.6706C10.9358 17 11.1901 16.8946 11.3777 16.7071C11.5652 16.5196 11.6706 16.2652 11.6706 16C11.6706 15.7348 11.5652 15.4804 11.3777 15.2929C11.1901 15.1054 10.9358 15 10.6706 15H5.33724Z"
      fill="black"
    />
  </svg>
);

export const cashIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.668 6.6665C27.3752 6.6665 28.0535 6.94746 28.5536 7.44755C29.0537 7.94765 29.3346 8.62593 29.3346 9.33317V22.6665C29.3346 23.3737 29.0537 24.052 28.5536 24.5521C28.0535 25.0522 27.3752 25.3332 26.668 25.3332H5.33464C4.62739 25.3332 3.94911 25.0522 3.44902 24.5521C2.94892 24.052 2.66797 23.3737 2.66797 22.6665V9.33317C2.66797 8.62593 2.94892 7.94765 3.44902 7.44755C3.94911 6.94746 4.62739 6.6665 5.33464 6.6665H26.668ZM5.5013 18.6665L5.33464 18.6705V21.3452C5.50021 21.3213 5.66899 21.3333 5.82952 21.3803C5.99006 21.4274 6.13859 21.5084 6.26505 21.6179C6.39151 21.7275 6.49294 21.8629 6.56246 22.0151C6.63198 22.1672 6.66796 22.3325 6.66797 22.4998L6.6653 22.5838L6.65464 22.6665H9.3293L9.33464 22.4998C9.33464 21.4832 8.93077 20.5082 8.21188 19.7893C7.49299 19.0704 6.51797 18.6665 5.5013 18.6665ZM26.5013 18.6665C25.5237 18.6665 24.583 19.0401 23.8716 19.7107C23.1603 20.3814 22.7321 21.2985 22.6746 22.2745L22.668 22.4998C22.668 22.5558 22.668 22.6118 22.672 22.6665H25.3466C25.3207 22.487 25.337 22.3039 25.3943 22.1317C25.4515 21.9596 25.5481 21.8032 25.6764 21.6749C25.8047 21.5467 25.9611 21.4501 26.1332 21.3928C26.3053 21.3356 26.4884 21.3193 26.668 21.3452V18.6705L26.5013 18.6665ZM16.0013 10.6665C14.5868 10.6665 13.2303 11.2284 12.2301 12.2286C11.2299 13.2288 10.668 14.5853 10.668 15.9998C10.668 17.4143 11.2299 18.7709 12.2301 19.7711C13.2303 20.7713 14.5868 21.3332 16.0013 21.3332C17.4158 21.3332 18.7723 20.7713 19.7725 19.7711C20.7727 18.7709 21.3346 17.4143 21.3346 15.9998C21.3346 14.5853 20.7727 13.2288 19.7725 12.2286C18.7723 11.2284 17.4158 10.6665 16.0013 10.6665ZM16.0013 13.3332C16.7085 13.3332 17.3868 13.6141 17.8869 14.1142C18.387 14.6143 18.668 15.2926 18.668 15.9998C18.668 16.7071 18.387 17.3854 17.8869 17.8855C17.3868 18.3856 16.7085 18.6665 16.0013 18.6665C15.2941 18.6665 14.6158 18.3856 14.1157 17.8855C13.6156 17.3854 13.3346 16.7071 13.3346 15.9998C13.3346 15.2926 13.6156 14.6143 14.1157 14.1142C14.6158 13.6141 15.2941 13.3332 16.0013 13.3332ZM9.33464 9.33317H6.66797V9.49984C6.66796 9.66713 6.63198 9.83246 6.56246 9.98462C6.49294 10.1368 6.39151 10.2722 6.26505 10.3817C6.13859 10.4912 5.99006 10.5723 5.82952 10.6193C5.66899 10.6664 5.50021 10.6784 5.33464 10.6545V13.3292L5.5013 13.3332C6.0047 13.3332 6.50317 13.234 6.96826 13.0414C7.43334 12.8487 7.85592 12.5664 8.21188 12.2104C8.56784 11.8545 8.8502 11.4319 9.04284 10.9668C9.23548 10.5017 9.33464 10.0032 9.33464 9.49984V9.33317ZM25.3466 9.33317H22.672L22.668 9.49984C22.668 10.4775 23.0415 11.4182 23.7122 12.1295C24.3829 12.8408 25.3 13.269 26.276 13.3265L26.5853 13.3318L26.668 13.3292V10.6545C26.5024 10.6784 26.3336 10.6664 26.1731 10.6193C26.0126 10.5723 25.864 10.4912 25.7376 10.3817C25.6111 10.2722 25.5097 10.1368 25.4401 9.98462C25.3706 9.83246 25.3346 9.66713 25.3346 9.49984L25.3373 9.41584L25.3466 9.33317Z"
      fill="black"
    />
  </svg>
);

const props = (active) => ({
  fillOpacity: active ? "" : "0.1",
  fill: getBackgroundColor(active),
});

export const addressHome = (active) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ backgroundColor: getBackgroundColor(active) }}
  >
    <rect width="40" height="40" rx="8" {...props(active)} />
    <path
      d="M13.7249 15.8555L13.2481 15.2765L13.2481 15.2765L13.7249 15.8555ZM17.8915 12.4245L17.4148 11.8456V11.8456L17.8915 12.4245ZM22.1084 12.4245L21.6317 13.0035L22.1084 12.4245ZM26.2751 15.8555L25.7984 16.4345L25.7984 16.4345L26.2751 15.8555ZM26.75 18.4587V24.9725H28.25V18.4587H26.75ZM24.1667 27.5834H15.8333V29.0834H24.1667V27.5834ZM13.25 24.9725V18.4587H11.75V24.9725H13.25ZM14.2016 16.4345L18.3683 13.0035L17.4148 11.8456L13.2481 15.2765L14.2016 16.4345ZM21.6317 13.0035L25.7984 16.4345L26.7519 15.2765L22.5852 11.8456L21.6317 13.0035ZM18.3683 13.0035C19.3184 12.2212 20.6816 12.2212 21.6317 13.0035L22.5852 11.8456C21.0812 10.6071 18.9188 10.6071 17.4148 11.8456L18.3683 13.0035ZM15.8333 27.5834C14.4124 27.5834 13.25 26.4203 13.25 24.9725H11.75C11.75 27.237 13.5723 29.0834 15.8333 29.0834V27.5834ZM26.75 24.9725C26.75 26.4203 25.5876 27.5834 24.1667 27.5834V29.0834C26.4277 29.0834 28.25 27.237 28.25 24.9725H26.75ZM28.25 18.4587C28.25 17.2267 27.7011 16.0581 26.7519 15.2765L25.7984 16.4345C26.3995 16.9295 26.75 17.6724 26.75 18.4587H28.25ZM13.25 18.4587C13.25 17.6724 13.6005 16.9295 14.2016 16.4345L13.2481 15.2765C12.2989 16.0581 11.75 17.2267 11.75 18.4587H13.25ZM24.0833 28.3334V25.0001H22.5833V28.3334H24.0833ZM15.9167 25.0001V28.3334H17.4167V25.0001H15.9167ZM20 20.9167C17.7448 20.9167 15.9167 22.7449 15.9167 25.0001H17.4167C17.4167 23.5733 18.5733 22.4167 20 22.4167V20.9167ZM24.0833 25.0001C24.0833 22.7449 22.2552 20.9167 20 20.9167V22.4167C21.4267 22.4167 22.5833 23.5733 22.5833 25.0001H24.0833Z"
      fill={getFillColor(active)}
    />
  </svg>
);

export const paymentMethod = (active) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ backgroundColor: getBackgroundColor(active) }}
  >
    <rect width="40" height="40" rx="8" {...props(active)} />
    <path
      d="M15.0013 13.25H25.0013V11.75H15.0013V13.25ZM27.5846 15.8333V24.1667H29.0846V15.8333H27.5846ZM25.0013 26.75H15.0013V28.25H25.0013V26.75ZM12.418 24.1667V15.8333H10.918V24.1667H12.418ZM15.0013 26.75C13.5746 26.75 12.418 25.5934 12.418 24.1667H10.918C10.918 26.4218 12.7461 28.25 15.0013 28.25V26.75ZM27.5846 24.1667C27.5846 25.5934 26.428 26.75 25.0013 26.75V28.25C27.2565 28.25 29.0846 26.4218 29.0846 24.1667H27.5846ZM25.0013 13.25C26.428 13.25 27.5846 14.4066 27.5846 15.8333H29.0846C29.0846 13.5782 27.2565 11.75 25.0013 11.75V13.25ZM15.0013 11.75C12.7461 11.75 10.918 13.5782 10.918 15.8333H12.418C12.418 14.4066 13.5746 13.25 15.0013 13.25V11.75Z"
      fill={getFillColor(active)}
    />
    <path
      d="M11.668 15.8333V15.0833C11.2538 15.0833 10.918 15.419 10.918 15.8333H11.668ZM28.3346 15.8333H29.0846C29.0846 15.419 28.7488 15.0833 28.3346 15.0833V15.8333ZM28.3346 19.1666V19.9166C28.7488 19.9166 29.0846 19.5808 29.0846 19.1666H28.3346ZM11.668 19.1666H10.918C10.918 19.5808 11.2538 19.9166 11.668 19.9166V19.1666ZM11.668 16.5833H28.3346V15.0833H11.668V16.5833ZM27.5846 15.8333V19.1666H29.0846V15.8333H27.5846ZM28.3346 18.4166H11.668V19.9166H28.3346V18.4166ZM12.418 19.1666V15.8333H10.918V19.1666H12.418Z"
      fill={getFillColor(active)}
    />
    <path
      d="M16.6667 24.9167C17.0809 24.9167 17.4167 24.581 17.4167 24.1667C17.4167 23.7525 17.0809 23.4167 16.6667 23.4167V24.9167ZM15 23.4167C14.5858 23.4167 14.25 23.7525 14.25 24.1667C14.25 24.581 14.5858 24.9167 15 24.9167V23.4167ZM16.6667 23.4167H15V24.9167H16.6667V23.4167Z"
      fill={getFillColor(active)}
    />
  </svg>
);

export const review = (active) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ backgroundColor: getBackgroundColor(active) }}
  >
    <rect width="40" height="40" rx="8" fill="#A4A1AA" {...props(active)} />
    <path
      d="M13.332 15.6667C13.332 13.4576 15.1229 11.6667 17.332 11.6667H22.5085C23.5694 11.6667 24.5868 12.0882 25.3369 12.8383L27.1605 14.6618C27.9106 15.412 28.332 16.4294 28.332 17.4903V24.3334C28.332 26.5426 26.5412 28.3334 24.332 28.3334H17.332C15.1229 28.3334 13.332 26.5426 13.332 24.3334V15.6667Z"
      stroke={getFillColor(active)}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 15.8333L24.1667 15.8333"
      stroke={getFillColor(active)}
      strokeWidth="1.5"
      strokeLinecap="round"
      fill={getFillColor(active)}
    />
    <path
      d="M17.5 20H24.1667"
      stroke={getFillColor(active)}
      strokeWidth="1.5"
      strokeLinecap="round"
      fill={getFillColor(active)}
    />
    <path
      d="M17.5 24.1667H20.8333"
      stroke={getFillColor(active)}
      strokeWidth="1.5"
      strokeLinecap="round"
      fill={getFillColor(active)}
    />
  </svg>
);

export const emptyStateIcon = (
  <svg
    width="281"
    height="357"
    viewBox="0 0 281 357"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M141.651 191.671C141.651 192.301 141.14 192.812 140.51 192.812C139.879 192.812 139.368 192.301 139.368 191.671C139.368 191.04 139.879 190.529 140.51 190.529C141.14 190.529 141.651 191.04 141.651 191.671Z"
      fill="#CFCFCF"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M72.8281 18.5917V28.8148"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.6914 23.7032H77.9383"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M189.205 84.2571L189.197 84.2572C169.283 84.2571 148.889 83.4515 129.775 78.1276C110.989 72.9145 93.7836 62.8146 78.4977 51.1834M189.205 84.2571L79.2154 50.2357M189.205 84.2571C194.99 84.2166 200.759 84.0903 206.442 83.9658C207.449 83.9437 208.453 83.9217 209.454 83.9002M189.205 84.2571L209.429 82.7118M78.4977 51.1834C78.497 51.1828 78.4963 51.1823 78.4956 51.1817L79.2154 50.2357M78.4977 51.1834C78.4979 51.1835 78.498 51.1836 78.4982 51.1837L79.2154 50.2357M78.4977 51.1834C68.5454 43.6538 59.8021 37.9033 47.3452 38.7735L47.3359 38.7741L47.3266 38.7746C34.9336 39.4452 23.0821 44.0713 13.512 51.9733M79.2154 50.2357C69.2538 42.6992 60.1957 36.6842 47.2624 37.5876C34.6097 38.2723 22.5101 42.9971 12.7417 51.0678M13.512 51.9733C13.5163 51.9696 13.5205 51.9658 13.5248 51.9621L12.7417 51.0678M13.512 51.9733C13.5076 51.977 13.5032 51.9806 13.4988 51.9842L12.7417 51.0678M13.512 51.9733C5.61236 58.8987 2.19595 68.8204 1.59244 79.4271C0.988409 90.0428 3.21376 101.229 6.46891 110.466L6.4696 110.468C11.3196 124.306 21.1496 136.111 33.0127 146.064C44.872 156.013 58.7011 164.06 71.4473 170.398L71.4493 170.399C100.858 185.091 133.205 193.646 165.671 198.555L165.673 198.555C179.916 200.727 196.111 202.583 211.803 201.593C227.495 200.603 242.585 196.771 254.694 187.654M12.7417 51.0678C-3.71035 65.4752 -1.23779 92.1741 5.34777 110.861C15.238 139.081 45.3366 158.743 70.9181 171.462C100.47 186.226 132.946 194.809 165.493 199.73C194.023 204.081 230.683 207.219 255.409 188.604M254.694 187.654C254.693 187.654 254.693 187.655 254.693 187.655L255.409 188.604M254.694 187.654L255.409 188.604M254.694 187.654C265.748 179.308 272.877 165.543 276.539 150.483C280.199 135.434 280.359 119.245 277.616 106.232L277.612 106.211L277.608 106.19C276.309 98.688 272.318 91.9182 266.383 87.1504M255.409 188.604C278.114 171.462 284.342 132.377 278.779 105.987C277.429 98.1911 273.278 91.1567 267.106 86.2067M266.383 87.1504C266.39 87.1556 266.397 87.1608 266.404 87.166L267.106 86.2067M266.383 87.1504C266.376 87.1449 266.369 87.1395 266.362 87.134L267.106 86.2067M266.383 87.1504C258.749 81.5755 249.166 80.5929 239.07 81.1262C234.343 81.3758 229.557 81.9535 224.847 82.522C224.532 82.5601 224.217 82.5981 223.902 82.636C218.909 83.2372 214.003 83.8037 209.454 83.9002M267.106 86.2067C255.395 77.6369 239.455 79.5612 224.714 81.3407C219.376 81.9852 214.195 82.6107 209.429 82.7118M209.429 82.7118L209.454 83.9002M209.429 82.7118L209.454 83.9002C209.454 83.9002 209.454 83.9002 209.454 83.9002"
      fill="#F2F2F2"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M158.155 2.32991C158.155 2.96017 157.644 3.47109 157.014 3.47109C156.383 3.47109 155.872 2.96016 155.872 2.32991C155.872 1.69966 156.383 1.18873 157.014 1.18873C157.644 1.18873 158.155 1.69965 158.155 2.32991Z"
      fill="#CFCFCF"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M35.9492 186.084V196.307"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.8398 191.195H41.0629"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M226.487 240.551C225.411 240.866 223.812 241.184 221.708 241.494C217.341 242.138 210.99 242.723 203.104 243.215C187.341 244.198 165.548 244.807 141.464 244.807C117.38 244.807 95.5865 244.198 79.8242 243.215C71.9382 242.723 65.5865 242.138 61.2196 241.494C59.1165 241.184 57.5173 240.866 56.4407 240.551C57.5173 240.236 59.1165 239.918 61.2196 239.608C65.5865 238.964 71.9382 238.38 79.8242 237.888C95.5865 236.905 117.38 236.296 141.464 236.296C165.548 236.296 187.341 236.905 203.104 237.888C210.99 238.38 217.341 238.964 221.708 239.608C223.812 239.918 225.411 240.236 226.487 240.551ZM55.172 240.032C55.1733 240.032 55.1836 240.039 55.1988 240.054C55.1784 240.04 55.1707 240.032 55.172 240.032ZM55.172 241.071C55.1707 241.07 55.1784 241.063 55.1988 241.048C55.1836 241.063 55.1733 241.071 55.172 241.071ZM227.729 241.048C227.75 241.063 227.757 241.07 227.756 241.071C227.755 241.071 227.744 241.063 227.729 241.048ZM227.729 240.054C227.744 240.039 227.755 240.032 227.756 240.032C227.757 240.032 227.75 240.04 227.729 240.054Z"
      fill="#F2F2F2"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M211.637 181.043H211.626H60.872C60.0353 181.043 59.2087 180.861 58.4494 180.509L57.95 181.588L58.4494 180.509C57.69 180.158 57.0161 179.645 56.4742 179.008L55.5706 179.776L56.4742 179.008C55.9323 178.37 55.5354 177.623 55.3108 176.817C55.0864 176.011 55.0395 175.166 55.1735 174.341C55.1735 174.34 55.1736 174.34 55.1737 174.34L74.4544 57.4188L74.4553 57.4133C74.6711 56.0656 75.3608 54.8392 76.4004 53.9549C77.44 53.0705 78.7611 52.5863 80.1259 52.5894H80.1286H230.883C231.719 52.5895 232.544 52.7715 233.302 53.1229C234.06 53.4743 234.733 53.9866 235.273 54.6241C235.813 55.2617 236.207 56.0092 236.429 56.8147L237.575 56.499L236.429 56.8147C236.651 57.6202 236.695 58.4644 236.558 59.2886L236.557 59.2915L217.371 176.215L217.371 176.216C217.15 177.573 216.45 178.806 215.398 179.692C214.346 180.577 213.012 181.057 211.637 181.043Z"
      fill="#D2D2D2"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M213.475 48.3429L123.991 8.38949C121.353 7.21179 118.26 8.39536 117.082 11.0331L88.7215 74.5537C87.5438 77.1914 88.7274 80.2844 91.3651 81.4621L180.85 121.415C183.487 122.593 186.58 121.41 187.758 118.772L216.119 55.2513C217.297 52.6136 216.113 49.5206 213.475 48.3429Z"
      fill="white"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M137.113 60.649C139.469 57.3439 142.894 54.9549 146.81 53.8867C150.725 52.8185 154.889 53.1368 158.597 54.7877C162.304 56.4386 165.327 59.3205 167.153 62.9451C168.979 66.5698 169.495 70.7141 168.615 74.676"
      stroke="#131118"
      strokeWidth="1.61667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M181.162 54.6102C181.162 55.3061 180.598 55.8703 179.902 55.8703C179.206 55.8703 178.642 55.3061 178.642 54.6102C178.642 53.9143 179.206 53.3502 179.902 53.3502C180.598 53.3502 181.162 53.9143 181.162 54.6102Z"
      fill="#BABABA"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M145.697 38.7763C145.697 39.4722 145.133 40.0364 144.437 40.0364C143.741 40.0364 143.177 39.4722 143.177 38.7763C143.177 38.0804 143.741 37.5163 144.437 37.5163C145.133 37.5163 145.697 38.0804 145.697 38.7763Z"
      fill="#BABABA"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M210.951 182.185H59.4598C57.6164 182.178 55.8507 181.442 54.5495 180.136C53.2483 178.83 52.5176 177.062 52.5176 175.219V68.3995C52.4955 67.4728 52.6585 66.551 52.9971 65.6881C53.3358 64.8252 53.8433 64.0386 54.4898 63.3743C55.1363 62.7101 55.909 62.1816 56.7624 61.8197C57.6158 61.4579 58.5328 61.27 59.4598 61.2671H114.641C115.921 61.2718 117.175 61.6293 118.266 62.3004C119.356 62.9715 120.241 63.9301 120.822 65.071L128.691 80.477C129.27 81.6196 130.154 82.5797 131.245 83.2511C132.336 83.9224 133.592 84.2789 134.873 84.2809H210.951C212.793 84.2809 214.558 85.0123 215.86 86.3142C217.162 87.6161 217.894 89.3819 217.894 91.2231V175.219C217.894 177.062 217.163 178.83 215.862 180.136C214.561 181.442 212.795 182.178 210.951 182.185Z"
      fill="white"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.632 87.9184C178.88 87.9137 170.323 90.5046 163.044 95.3634C155.765 100.222 150.09 107.131 146.738 115.215C143.386 123.299 142.506 132.196 144.211 140.78C145.915 149.364 150.127 157.25 156.314 163.44C162.501 169.63 170.384 173.846 178.967 175.556C187.551 177.265 196.448 176.39 204.534 173.042C212.62 169.694 219.531 164.023 224.394 156.746C229.257 149.47 231.852 140.915 231.852 132.163C231.852 120.433 227.194 109.182 218.902 100.886C210.609 92.5889 199.362 87.9247 187.632 87.9184Z"
      fill="white"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M219.105 164.259L230.898 176.051"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M226.766 174.975L230.43 171.143C231.619 169.899 233.59 169.855 234.833 171.044L266.626 201.436C267.87 202.625 267.914 204.596 266.725 205.84L263.062 209.672C261.873 210.915 259.902 210.96 258.659 209.771L226.866 179.379C225.622 178.19 225.578 176.219 226.766 174.975Z"
      fill="#D2D2D2"
      stroke="#131118"
      strokeWidth="2.37746"
    />
    <path
      d="M253.105 2.32993V12.5768"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M247.969 7.46524H258.216"
      stroke="#131118"
      strokeWidth="2.37746"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const successIcon = (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="54" cy="54" r="54" fill="#131118" fillOpacity="0.05" />

    <g transform="translate(11, 11)">
      <svg
        width="86"
        height="86"
        viewBox="0 0 86 86"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="43" cy="43" r="43" fill="#131118" fillOpacity="0.1" />
      </svg>
    </g>

    <g transform="translate(22, 22)">
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="32" r="32" fill="#131118" />

        <g transform="translate(20, 20)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 6L9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7V6"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.6133 3H8.39031C6.43496 3 4.7662 4.41365 4.44474 6.3424L2.77807 16.3424C2.37172 18.7805 4.25189 21 6.72365 21H17.28C19.7517 21 21.6319 18.7805 21.2255 16.3424L19.5589 6.3424C19.2374 4.41365 17.5687 3 15.6133 3Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
        </g>
      </svg>
    </g>
  </svg>
);

export const unFavorite = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="white" />
    <path
      d="M12.1642 11L11 12.1904L12.8918 14.1401C12.2188 15.0025 11.8095 16.1179 11.8095 17.3458C11.8095 20.8796 14.9019 23.776 19.5859 28.1534L20.9047 29.3907L22.2236 28.1534C23.0148 27.4129 23.7607 26.7193 24.4519 26.0538L28.1809 30L29.336 28.8096M20.9957 26.7662L20.9047 26.8599L20.8047 26.7662C16.4844 22.7262 13.6285 20.0548 13.6285 17.3458C13.6285 16.6334 13.8286 15.9961 14.1833 15.4711L23.1786 24.7227C22.4873 25.3695 21.7688 26.0444 20.9957 26.7662ZM17.5395 14.1589L15.7477 12.3123C16.0843 12.2373 16.4481 12.1904 16.8119 12.1904C18.3944 12.1904 19.9134 12.9497 20.9047 14.1401C21.8961 12.9497 23.415 12.1904 24.9976 12.1904C27.7989 12.1904 30 14.4494 30 17.3458C30 19.5392 28.8085 21.4889 26.7894 23.6917L25.5069 22.37C27.1896 20.5141 28.1809 18.9393 28.1809 17.3458C28.1809 15.4711 26.8167 14.0651 24.9976 14.0651C23.7243 14.0651 22.4873 14.8431 21.9143 15.9398H19.8952C19.4313 15.0587 18.5309 14.3838 17.5395 14.1589Z"
      fill="#E14848"
    />
  </svg>
);

export const FavoriteIcon = (isFavorite = false) => {
  const heartFillColor = isFavorite ? "#E14848" : "#131118";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={heartFillColor}
      stroke={heartFillColor}
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: heartFillColor, fill: heartFillColor }}
    >
      <path d="M12 5.52422L11.451 6.03522C11.5929 6.18764 11.7918 6.27422 12 6.27422C12.2082 6.27422 12.4071 6.18764 12.549 6.03522L12 5.52422ZM12.765 4.70229L12.2161 4.1913V4.1913L12.765 4.70229ZM11.235 4.70229L11.7839 4.1913V4.1913L11.235 4.70229ZM3.58447 12.9217L3.03548 13.4326L3.58447 12.9217ZM10.4699 20.3191L11.0189 19.8081L10.4699 20.3191ZM13.5301 20.3191L12.9811 19.8081L13.5301 20.3191ZM20.4155 12.9217L19.8665 12.4107L20.4155 12.9217ZM20.4155 4.70229L20.9645 4.1913L20.4155 4.70229ZM3.58447 4.70229L3.03548 4.1913L3.58447 4.70229ZM12.549 6.03522L13.314 5.21328L12.2161 4.1913L11.451 5.01323L12.549 6.03522ZM10.686 5.21328L11.451 6.03522L12.549 5.01323L11.7839 4.1913L10.686 5.21328ZM3.03548 13.4326L9.92091 20.8301L11.0189 19.8081L4.13345 12.4107L3.03548 13.4326ZM14.0791 20.8301L20.9645 13.4326L19.8665 12.4107L12.9811 19.8081L14.0791 20.8301ZM19.8665 5.21328C21.7111 7.19505 21.7112 10.4289 19.8665 12.4107L20.9645 13.4326C23.3452 10.875 23.3452 6.74896 20.9645 4.1913L19.8665 5.21328ZM20.9645 4.1913C18.5553 1.6029 14.6253 1.6029 12.2161 4.1913L13.314 5.21328C15.13 3.26224 18.0505 3.26224 19.8665 5.21328L20.9645 4.1913ZM4.13346 5.21328C5.94946 3.26224 8.86996 3.26224 10.686 5.21328L11.7839 4.1913C9.3747 1.6029 5.44472 1.6029 3.03548 4.1913L4.13346 5.21328ZM9.92091 20.8301C11.0626 22.0566 12.9374 22.0566 14.0791 20.8301L12.9811 19.8081C12.4327 20.3973 11.5673 20.3973 11.0189 19.8081L9.92091 20.8301ZM3.03548 4.1913C0.654841 6.74896 0.65484 10.875 3.03548 13.4326L4.13345 12.4107C2.28885 10.4289 2.28885 7.19505 4.13346 5.21328L3.03548 4.1913Z" />
    </svg>
  );
};

export const starIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0328 3.27141C10.8375 1.5762 13.1625 1.5762 13.9672 3.27141L15.3579 6.20118C15.6774 6.87435 16.2951 7.34094 17.0096 7.44888L20.1193 7.91869C21.9187 8.19053 22.6371 10.4895 21.3351 11.8091L19.0849 14.0896C18.5679 14.6136 18.332 15.3685 18.454 16.1084L18.9852 19.3285C19.2926 21.1918 17.4116 22.6126 15.8022 21.7329L13.0208 20.2126C12.3817 19.8633 11.6183 19.8633 10.9792 20.2126L8.19776 21.7329C6.58839 22.6126 4.70742 21.1918 5.01479 19.3286L5.54599 16.1084C5.66804 15.3685 5.43211 14.6136 4.91508 14.0896L2.66488 11.8091C1.36287 10.4895 2.08133 8.19053 3.88066 7.91869L6.99037 7.44888C7.70489 7.34094 8.32257 6.87435 8.64211 6.20118L10.0328 3.27141Z"
      fill="#F59E0B"
    />
  </svg>
);

export const searchIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 11.5C2.75 16.3325 6.66751 20.25 11.5 20.25C16.3325 20.25 20.25 16.3325 20.25 11.5C20.25 6.66751 16.3325 2.75 11.5 2.75C6.66751 2.75 2.75 6.66751 2.75 11.5ZM11.5 21.75C5.83908 21.75 1.25 17.1609 1.25 11.5C1.25 5.83908 5.83908 1.25 11.5 1.25C17.1609 1.25 21.75 5.83908 21.75 11.5C21.75 14.0605 20.8111 16.4017 19.2589 18.1982L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L18.1982 19.2589C16.4017 20.8111 14.0605 21.75 11.5 21.75Z"
      fill="#131118"
    />
  </svg>
);

export const searchLogo = (isFaded = false) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.94286 3C10.519 3 12.0306 3.62612 13.1451 4.74062C14.2596 5.85512 14.8857 7.36671 14.8857 8.94286C14.8857 10.4149 14.3463 11.768 13.4594 12.8103L13.7063 13.0571H14.4286L19 17.6286L17.6286 19L13.0571 14.4286V13.7063L12.8103 13.4594C11.768 14.3463 10.4149 14.8857 8.94286 14.8857C7.36671 14.8857 5.85512 14.2596 4.74062 13.1451C3.62612 12.0306 3 10.519 3 8.94286C3 7.36671 3.62612 5.85512 4.74062 4.74062C5.85512 3.62612 7.36671 3 8.94286 3ZM8.94286 4.82857C6.65714 4.82857 4.82857 6.65714 4.82857 8.94286C4.82857 11.2286 6.65714 13.0571 8.94286 13.0571C11.2286 13.0571 13.0571 11.2286 13.0571 8.94286C13.0571 6.65714 11.2286 4.82857 8.94286 4.82857Z"
      fill={isFaded ? "#CCCCCC" : "#2B2B2B"}
    />
  </svg>
);

export const shopCart = (
  <svg
    width="29"
    height="26"
    viewBox="0 0 29 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6L9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7V6"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6133 3H8.39031C6.43496 3 4.7662 4.41365 4.44474 6.3424L2.77807 16.3424C2.37172 18.7805 4.25189 21 6.72365 21H17.28C19.7517 21 21.6319 18.7805 21.2255 16.3424L19.5589 6.3424C19.2374 4.41365 17.5687 3 15.6133 3Z"
      stroke="#131118"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const X = (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29 16.41L27.59 15L22 20.59L16.41 15L15 16.41L20.59 22L15 27.59L16.41 29L22 23.41L27.59 29L29 27.59L23.41 22L29 16.41Z"
      fill="#2B2B2B"
    />
  </svg>
);

export const X12 = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.77441 8.97705C9.88009 9.08272 9.93945 9.22605 9.93945 9.37549C9.93945 9.52493 9.88009 9.66825 9.77441 9.77393C9.66874 9.8796 9.52542 9.93897 9.37598 9.93897C9.22653 9.93897 9.08321 9.8796 8.97754 9.77393L6.00144 6.7969L3.02441 9.77299C2.91874 9.87866 2.77542 9.93803 2.62598 9.93803C2.47653 9.93803 2.33321 9.87866 2.22754 9.77299C2.12187 9.66732 2.0625 9.524 2.0625 9.37455C2.0625 9.22511 2.12187 9.08179 2.22754 8.97612L5.20457 6.00002L2.22848 3.02299C2.1228 2.91732 2.06344 2.774 2.06344 2.62455C2.06344 2.47511 2.1228 2.33179 2.22848 2.22611C2.33415 2.12044 2.47747 2.06108 2.62691 2.06108C2.77636 2.06108 2.91968 2.12044 3.02535 2.22611L6.00144 5.20315L8.97848 2.22565C9.08415 2.11997 9.22747 2.06061 9.37691 2.06061C9.52636 2.06061 9.66968 2.11997 9.77535 2.22565C9.88102 2.33132 9.94039 2.47464 9.94039 2.62408C9.94039 2.77353 9.88102 2.91685 9.77535 3.02252L6.79832 6.00002L9.77441 8.97705Z"
      fill="black"
    />
  </svg>
);

export const barDown = (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 23H28V21H16V23ZM13 16V18H31V16H13ZM20 28H24V26H20V28Z"
      fill="#2B2B2B"
    />
  </svg>
);

export const arrowRightIcon = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5303 12.2997C18.8232 12.5926 18.8232 13.0675 18.5303 13.3604L14.5303 17.3604C14.2374 17.6533 13.7626 17.6533 13.4697 17.3604C13.1768 17.0675 13.1768 16.5926 13.4697 16.2997L16.1893 13.5801L6 13.5801C5.58579 13.5801 5.25 13.2443 5.25 12.8301C5.25 12.4159 5.58579 12.0801 6 12.0801L16.1893 12.0801L13.4697 9.36041C13.1768 9.06751 13.1768 8.59264 13.4697 8.29975C13.7626 8.00685 14.2374 8.00685 14.5303 8.29975L18.5303 12.2997Z"
      fill="white"
    />
  </svg>
);

export const shopLeft = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="56"
      height="56"
      rx="10"
      transform="matrix(-1 0 0 1 56 0)"
      fill="#A4A1AA"
      fill-opacity="0.1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4697 27.4697C21.1768 27.7626 21.1768 28.2374 21.4697 28.5303L25.4697 32.5303C25.7626 32.8232 26.2374 32.8232 26.5303 32.5303C26.8232 32.2374 26.8232 31.7626 26.5303 31.4697L23.8107 28.75L34 28.75C34.4142 28.75 34.75 28.4142 34.75 28C34.75 27.5858 34.4142 27.25 34 27.25L23.8107 27.25L26.5303 24.5303C26.8232 24.2374 26.8232 23.7626 26.5303 23.4697C26.2374 23.1768 25.7626 23.1768 25.4697 23.4697L21.4697 27.4697Z"
      fill="#131118"
    />
  </svg>
);

export const shopRight = (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" rx="10" fill="#E14848" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.5303 27.4697C34.8232 27.7626 34.8232 28.2374 34.5303 28.5303L30.5303 32.5303C30.2374 32.8232 29.7626 32.8232 29.4697 32.5303C29.1768 32.2374 29.1768 31.7626 29.4697 31.4697L32.1893 28.75L22 28.75C21.5858 28.75 21.25 28.4142 21.25 28C21.25 27.5858 21.5858 27.25 22 27.25L32.1893 27.25L29.4697 24.5303C29.1768 24.2374 29.1768 23.7626 29.4697 23.4697C29.7626 23.1768 30.2374 23.1768 30.5303 23.4697L34.5303 27.4697Z"
      fill="white"
    />
  </svg>
);

export const phone = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 16L14.8529 16.7354C15.1846 16.8018 15.5196 16.6379 15.6708 16.3354L15 16ZM8 9L7.66459 8.32918C7.36208 8.48043 7.19824 8.81544 7.26456 9.14709L8 9ZM8.35402 8.82299L8.68943 9.49381L8.68943 9.49381L8.35402 8.82299ZM9.31654 6.29136L10.0129 6.01281L9.31654 6.29136ZM8.50289 4.25722L7.80653 4.53576L8.50289 4.25722ZM19.7428 15.4971L19.4642 16.1935L19.7428 15.4971ZM17.7086 14.6835L17.9872 13.9871H17.9872L17.7086 14.6835ZM15.177 15.646L15.8478 15.9814V15.9814L15.177 15.646ZM16.25 11C16.25 11.4142 16.5858 11.75 17 11.75C17.4142 11.75 17.75 11.4142 17.75 11H16.25ZM16.6955 9.46927L17.3884 9.18225L16.6955 9.46927ZM14.5307 7.30448L14.8177 6.61157L14.5307 7.30448ZM13 6.25C12.5858 6.25 12.25 6.58579 12.25 7C12.25 7.41421 12.5858 7.75 13 7.75V6.25ZM20.25 11C20.25 11.4142 20.5858 11.75 21 11.75C21.4142 11.75 21.75 11.4142 21.75 11H20.25ZM20.391 7.93853L21.0839 7.65152L20.391 7.93853ZM16.0615 3.60896L16.3485 2.91605V2.91605L16.0615 3.60896ZM13 2.25C12.5858 2.25 12.25 2.58579 12.25 3C12.25 3.41421 12.5858 3.75 13 3.75V2.25ZM20.25 17.3541V19H21.75V17.3541H20.25ZM5 3.75H6.64593V2.25H5V3.75ZM15 16C15.1471 15.2646 15.1473 15.2646 15.1475 15.2646C15.1476 15.2647 15.1477 15.2647 15.1479 15.2647C15.1481 15.2648 15.1483 15.2648 15.1484 15.2648C15.1487 15.2649 15.1488 15.2649 15.1488 15.2649C15.1488 15.2649 15.1482 15.2648 15.147 15.2645C15.1447 15.264 15.14 15.2631 15.1331 15.2615C15.1193 15.2585 15.0967 15.2533 15.0659 15.2459C15.0044 15.2309 14.9104 15.2066 14.7898 15.1711C14.5482 15.1 14.2016 14.9847 13.7954 14.8106C12.9796 14.461 11.9439 13.8833 11.0303 12.9697L9.96967 14.0303C11.0561 15.1167 12.2704 15.789 13.2046 16.1894C13.6734 16.3903 14.0768 16.525 14.3665 16.6101C14.5115 16.6528 14.6285 16.6832 14.7114 16.7034C14.7529 16.7135 14.7859 16.721 14.8097 16.7263C14.8217 16.7289 14.8313 16.7309 14.8385 16.7325C14.8421 16.7332 14.8451 16.7339 14.8475 16.7343C14.8487 16.7346 14.8498 16.7348 14.8507 16.735C14.8511 16.7351 14.8515 16.7352 14.8519 16.7352C14.8521 16.7353 14.8523 16.7353 14.8524 16.7353C14.8527 16.7354 14.8529 16.7354 15 16ZM11.0303 12.9697C10.1167 12.0561 9.53901 11.0204 9.18936 10.2046C9.01527 9.79836 8.89996 9.45184 8.8289 9.21025C8.79342 9.08962 8.76912 8.99565 8.75414 8.93406C8.74666 8.90329 8.74151 8.88065 8.73847 8.86687C8.73695 8.85999 8.73595 8.85532 8.73546 8.85296C8.73521 8.85178 8.73509 8.85118 8.73508 8.85117C8.73508 8.85116 8.73511 8.8513 8.73517 8.85159C8.7352 8.85174 8.73524 8.85192 8.73528 8.85214C8.7353 8.85225 8.73534 8.85244 8.73535 8.8525C8.73539 8.8527 8.73544 8.85291 8 9C7.26456 9.14709 7.26461 9.14732 7.26466 9.14756C7.26468 9.14765 7.26473 9.1479 7.26477 9.14809C7.26484 9.14846 7.26492 9.14887 7.26501 9.14932C7.2652 9.15022 7.26541 9.15127 7.26566 9.15247C7.26615 9.15488 7.26677 9.15789 7.26753 9.1615C7.26905 9.16873 7.27111 9.17834 7.27374 9.19026C7.279 9.21408 7.28655 9.2471 7.29664 9.28859C7.31682 9.37154 7.34721 9.48851 7.38985 9.6335C7.47504 9.92316 7.60973 10.3266 7.81064 10.7954C8.21099 11.7296 8.88325 12.9439 9.96967 14.0303L11.0303 12.9697ZM8.33541 9.67082L8.68943 9.49381L8.01861 8.15217L7.66459 8.32918L8.33541 9.67082ZM10.0129 6.01281L9.19925 3.97868L7.80653 4.53576L8.62018 6.5699L10.0129 6.01281ZM20.0213 14.8008L17.9872 13.9871L17.4301 15.3798L19.4642 16.1935L20.0213 14.8008ZM14.5062 15.3106L14.3292 15.6646L15.6708 16.3354L15.8478 15.9814L14.5062 15.3106ZM17.9872 13.9871C16.6592 13.4559 15.1458 14.0313 14.5062 15.3106L15.8478 15.9814C16.1386 15.3999 16.8265 15.1384 17.4301 15.3798L17.9872 13.9871ZM8.68943 9.49381C9.96868 8.85419 10.5441 7.34076 10.0129 6.01281L8.62018 6.5699C8.86163 7.17351 8.60008 7.86143 8.01861 8.15217L8.68943 9.49381ZM6.64593 3.75C7.15706 3.75 7.6167 4.06119 7.80653 4.53576L9.19925 3.97868C8.78162 2.93462 7.77042 2.25 6.64593 2.25V3.75ZM21.75 17.3541C21.75 16.2296 21.0654 15.2184 20.0213 14.8008L19.4642 16.1935C19.9388 16.3833 20.25 16.8429 20.25 17.3541H21.75ZM19 20.25C10.5777 20.25 3.75 13.4223 3.75 5H2.25C2.25 14.2508 9.74923 21.75 19 21.75V20.25ZM19 21.75C20.5188 21.75 21.75 20.5188 21.75 19H20.25C20.25 19.6904 19.6904 20.25 19 20.25V21.75ZM3.75 5C3.75 4.30964 4.30964 3.75 5 3.75V2.25C3.48122 2.25 2.25 3.48122 2.25 5H3.75ZM17.75 11C17.75 10.3762 17.6271 9.75855 17.3884 9.18225L16.0026 9.75628C16.1659 10.1506 16.25 10.5732 16.25 11H17.75ZM17.3884 9.18225C17.1497 8.60596 16.7998 8.08232 16.3588 7.64124L15.2981 8.7019C15.5999 9.00369 15.8393 9.36197 16.0026 9.75628L17.3884 9.18225ZM16.3588 7.64124C15.9177 7.20016 15.394 6.85028 14.8177 6.61157L14.2437 7.99739C14.638 8.16072 14.9963 8.40011 15.2981 8.7019L16.3588 7.64124ZM14.8177 6.61157C14.2415 6.37286 13.6238 6.25 13 6.25V7.75C13.4268 7.75 13.8494 7.83406 14.2437 7.99739L14.8177 6.61157ZM21.75 11C21.75 9.85093 21.5237 8.71312 21.0839 7.65152L19.6981 8.22554C20.0625 9.10516 20.25 10.0479 20.25 11H21.75ZM21.0839 7.65152C20.6442 6.58992 19.9997 5.62533 19.1872 4.81282L18.1265 5.87348C18.7997 6.5467 19.3338 7.34593 19.6981 8.22554L21.0839 7.65152ZM19.1872 4.81282C18.3747 4.0003 17.4101 3.35578 16.3485 2.91605L15.7745 4.30187C16.6541 4.66622 17.4533 5.20025 18.1265 5.87348L19.1872 4.81282ZM16.3485 2.91605C15.2869 2.47633 14.1491 2.25 13 2.25V3.75C13.9521 3.75 14.8948 3.93753 15.7745 4.30187L16.3485 2.91605Z"
      fill="#E14848"
    />
  </svg>
);

export const email = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="3"
      width="20"
      height="18"
      rx="4"
      stroke="#E14848"
      strokeWidth="1.5"
    />
    <path
      d="M2 7L9.50122 13.001C10.9621 14.1697 13.0379 14.1697 14.4988 13.001L22 7"
      stroke="#E14848"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const location = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="11" r="3" stroke="#E14848" strokeWidth="1.5" />
    <path
      d="M21 10.8889C21 15.7981 15.375 22 12 22C8.625 22 3 15.7981 3 10.8889C3 5.97969 7.02944 2 12 2C16.9706 2 21 5.97969 21 10.8889Z"
      stroke="#E14848"
      strokeWidth="1.5"
    />
  </svg>
);

export const visa = (
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="35" height="23" rx="1.9" stroke="black" />
    <path
      d="M24.3732 7.86976C23.9298 7.69386 23.2265 7.49963 22.357 7.49963C20.137 7.49963 18.5738 8.68341 18.5642 10.3759C18.5458 11.6245 19.6834 12.3181 20.5343 12.7344C21.404 13.1599 21.6997 13.4376 21.6997 13.8168C21.6908 14.3992 20.9969 14.6677 20.3497 14.6677C19.4522 14.6677 18.9713 14.5293 18.2405 14.2052L17.9445 14.0663L17.63 16.0179C18.1572 16.2581 19.1286 16.4713 20.137 16.4806C22.4958 16.4806 24.0313 15.3151 24.0495 13.5116C24.0585 12.5219 23.4578 11.7636 22.1626 11.1439C21.3764 10.7461 20.8949 10.4779 20.8949 10.0709C20.9041 9.70087 21.3021 9.32189 22.1897 9.32189C22.9205 9.30332 23.4574 9.47899 23.8642 9.65477L24.0675 9.74709L24.3732 7.86976Z"
      fill="#3362AB"
    />
    <path
      d="M16.2242 16.351H13.9762L15.3823 7.65722H17.6301L16.2242 16.351Z"
      fill="#3362AB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.1357 7.65722H28.3969C27.8607 7.65722 27.4533 7.81432 27.222 8.37855L23.883 16.3509H26.2417C26.2417 16.3509 26.63 15.2779 26.7134 15.0468H29.5996C29.6641 15.352 29.8678 16.3509 29.8678 16.3509H31.9492L30.1357 7.65722ZM27.3609 13.2711C27.546 12.7717 28.2584 10.8387 28.2584 10.8387C28.2546 10.8461 28.2836 10.7658 28.3268 10.646L28.3273 10.6446L28.3277 10.6436C28.3922 10.4647 28.488 10.1992 28.5541 10.0063L28.7112 10.7554C28.7112 10.7554 29.1369 12.8365 29.2294 13.2711H27.3609Z"
      fill="#3362AB"
    />
    <path
      d="M12.0987 7.65722L9.8972 13.5856L9.65663 12.3832L9.65641 12.3825L8.8704 8.38802C8.74096 7.83276 8.34317 7.67554 7.85294 7.65722H4.23622L4.19922 7.83289C5.08132 8.05846 5.87029 8.3835 6.56158 8.78766L8.56518 16.3418H10.9423L14.4757 7.65722H12.0987Z"
      fill="#3362AB"
    />
  </svg>
);

export const masterCard = (
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="35" height="23" rx="1.9" stroke="black" />
    <path
      d="M30 11.9166C30 16.0162 26.6833 19.3329 22.5837 19.3329C20.8532 19.3329 19.267 18.7355 18.0103 17.7467C19.7408 16.387 20.8326 14.2857 20.8326 11.9166C20.8326 9.54752 19.7202 7.44623 18.0103 6.08657C19.267 5.09773 20.8532 4.50031 22.5837 4.50031C26.6833 4.50031 30 7.83765 30 11.9166Z"
      fill="#F79E1B"
    />
    <path
      d="M18.0103 6.08657C18.0103 6.08657 18.0103 6.08657 18.0103 6.08657C19.7202 7.44623 20.8326 9.54752 20.8326 11.9166C20.8326 14.2857 19.7408 16.387 18.0103 17.7467L17.9896 17.7467C16.2798 16.4076 15.1674 14.2857 15.1674 11.9167C15.1674 9.54756 16.2798 7.44627 17.9897 6.08662C17.9897 6.0866 17.9897 6.08663 17.9897 6.08662L18.0103 6.08657Z"
      fill="#FF5F00"
    />
    <path
      d="M15.1674 11.9167C15.1674 9.54756 16.2798 7.44627 17.9897 6.08662C16.733 5.09778 15.1468 4.50034 13.4163 4.50034C9.31674 4.50034 6 7.81708 6 11.9166C6 16.0162 9.31674 19.333 13.4163 19.333C15.1468 19.333 16.733 18.7355 17.9896 17.7467C16.2798 16.4076 15.1674 14.2857 15.1674 11.9167Z"
      fill="#EB001B"
    />
  </svg>
);

export const gPay = (
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="35" height="23" rx="1.9" stroke="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9516 14.9685V11.9415H18.5139C19.1541 11.9415 19.6945 11.727 20.1349 11.304L20.2407 11.1967C21.0453 10.3208 20.9924 8.95626 20.1349 8.14589C19.7062 7.71686 19.1189 7.48448 18.5139 7.49639H16.006V14.9685H16.9516ZM16.9517 11.0239V8.41401H18.5378C18.8785 8.41401 19.2016 8.5451 19.4424 8.78344C19.9535 9.28397 19.9652 10.1182 19.4718 10.6366C19.2309 10.8928 18.8902 11.0358 18.5378 11.0239H16.9517Z"
      fill="#3C4043"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6515 10.2553C24.2463 9.87986 23.6942 9.68918 22.9953 9.68918C22.0966 9.68918 21.4212 10.0229 20.9749 10.6843L21.8089 11.2146C22.1143 10.7617 22.5313 10.5353 23.0599 10.5353C23.3946 10.5353 23.7177 10.6604 23.9702 10.8869C24.2169 11.1014 24.3579 11.4112 24.3579 11.739V11.9594C23.9937 11.7568 23.5356 11.6496 22.9718 11.6496C22.314 11.6496 21.7854 11.8045 21.3919 12.1203C20.9983 12.4361 20.7987 12.8532 20.7987 13.3835C20.7869 13.8662 20.9925 14.325 21.3566 14.6349C21.7266 14.9686 22.1965 15.1354 22.7486 15.1354C23.4005 15.1354 23.9174 14.8434 24.3109 14.2595H24.352V14.9686H25.2565V11.8164C25.2565 11.155 25.0568 10.6306 24.6515 10.2553ZM22.0851 14.0271C21.8912 13.8841 21.7737 13.6517 21.7737 13.4014C21.7737 13.1214 21.903 12.889 22.1556 12.7043C22.414 12.5195 22.7371 12.4242 23.1189 12.4242C23.6476 12.4182 24.0588 12.5374 24.3525 12.7758C24.3525 13.1809 24.1939 13.5325 23.8826 13.8304C23.6006 14.1165 23.2188 14.2773 22.8193 14.2773C22.555 14.2833 22.2965 14.1939 22.0851 14.0271Z"
      fill="#3C4043"
    />
    <path
      d="M27.2886 17.215L30.4485 9.85603H29.4206L27.9582 13.5266H27.9406L26.4429 9.85603H25.4151L27.4883 14.6408L26.3137 17.215H27.2886Z"
      fill="#3C4043"
    />
    <path
      d="M13.6871 11.2861C13.6871 10.9941 13.6636 10.7021 13.6166 10.4161H9.62864V12.0667H11.9133C11.8194 12.597 11.514 13.0737 11.0676 13.3716V14.4442H12.4302C13.229 13.6993 13.6871 12.597 13.6871 11.2861Z"
      fill="#4285F4"
    />
    <path
      d="M9.62881 15.481C10.7682 15.481 11.7313 15.0996 12.4302 14.4442L11.0676 13.3716C10.6858 13.6338 10.1985 13.7828 9.62881 13.7828C8.52463 13.7828 7.59078 13.026 7.256 12.0131H5.85229V13.1214C6.56883 14.5693 8.03127 15.481 9.62881 15.481Z"
      fill="#34A853"
    />
    <path
      d="M7.256 12.0131C7.07977 11.4827 7.07993 10.9048 7.25616 10.3685V9.26613H5.85222C5.24718 10.4757 5.24718 11.9058 5.85222 13.1154L7.256 12.0131Z"
      fill="#FBBC04"
    />
    <path
      d="M9.62881 8.59874C10.2338 8.58683 10.8152 8.81921 11.2498 9.24228L12.4597 8.0148C11.6903 7.28784 10.6801 6.88861 9.62881 6.90053C8.03127 6.90053 6.56876 7.81818 5.85222 9.26613L7.256 10.3744C7.59078 9.35549 8.52463 8.59874 9.62881 8.59874Z"
      fill="#EA4335"
    />
  </svg>
);

export const amex = (
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="35" height="23" rx="1.9" stroke="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.88278 8.40039L3.60156 15.6616H7.52965L8.01661 14.5039H9.12971L9.61668 15.6616H13.9404V14.778L14.3257 15.6616H16.5622L16.9475 14.7593V15.6616H25.9397L27.0331 14.5339L28.0569 15.6616L32.6754 15.671L29.3838 12.0513L32.6754 8.40039H28.1285L27.0641 9.50723L26.0726 8.40039H16.2903L15.4503 10.2746L14.5906 8.40039H10.6707V9.25395L10.2346 8.40039H6.88278ZM20.3107 9.4315H25.4745L27.0538 11.1375L28.684 9.4315H30.2634L27.8637 12.0503L30.2634 14.6388H28.6124L27.0331 12.913L25.3945 14.6388H20.3107V9.4315ZM21.5859 11.4615V10.5094H24.8079L26.2138 12.0305L24.7456 13.56H21.5859V12.5216H24.4029V11.4615H21.5859ZM7.64285 9.4315H9.55758L11.734 14.3554V9.4315H13.8315L15.5126 12.9619L17.0618 9.4315H19.1489V14.6419H17.879L17.8686 10.5591L16.0172 14.6419H14.8812L13.0194 10.5591V14.6419H10.4069L9.91164 13.4738H7.23583L6.74157 14.6409H5.34182L7.64285 9.4315ZM7.69272 12.394L8.5743 10.3131L9.45485 12.394H7.69272Z"
      fill="black"
    />
  </svg>
);

export const paypal = (
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="35" height="23" rx="1.9" stroke="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.4877 8.23753C23.4731 8.3318 23.4563 8.42812 23.4374 8.52711C22.7886 11.8719 20.5688 13.0274 17.7338 13.0274H16.2903C15.9436 13.0274 15.6514 13.2801 15.5974 13.6235L14.6491 19.6636C14.6139 19.8891 14.787 20.0923 15.0136 20.0923H17.5738C17.8769 20.0923 18.1345 19.8711 18.1822 19.5709L18.2073 19.4404L18.6894 16.3689L18.7204 16.2005C18.7676 15.8992 19.0257 15.678 19.3288 15.678H19.7117C22.1921 15.678 24.134 14.6669 24.7016 11.7408C24.9385 10.5184 24.8159 9.49777 24.1885 8.77995C23.9987 8.56354 23.7632 8.38387 23.4877 8.23753Z"
      fill="#298FC2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8087 7.96585C22.7095 7.93679 22.6073 7.91053 22.5024 7.88678C22.3969 7.86362 22.2889 7.84312 22.1777 7.82512C21.7885 7.76198 21.362 7.73204 20.9052 7.73204H17.0489C16.9539 7.73204 16.8637 7.75357 16.783 7.79252C16.6051 7.87837 16.473 8.04743 16.441 8.25439L15.6206 13.4715L15.5971 13.6236C15.651 13.2801 15.9432 13.0274 16.2899 13.0274H17.7334C20.5684 13.0274 22.7883 11.8714 23.4371 8.52715C23.4565 8.42817 23.4728 8.33184 23.4873 8.23758C23.3232 8.1501 23.1454 8.07531 22.954 8.01158C22.9067 7.9958 22.8579 7.9806 22.8087 7.96585Z"
      fill="#22284F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.441 8.25439C16.473 8.04743 16.6053 7.87839 16.7832 7.79312C16.8645 7.75403 16.9541 7.73249 17.0491 7.73249H20.9054C21.3622 7.73249 21.7887 7.76259 22.1779 7.82572C22.2891 7.84357 22.3971 7.86423 22.5026 7.88739C22.6075 7.91099 22.7097 7.93739 22.8089 7.96631C22.8581 7.98106 22.9069 7.9964 22.9546 8.0116C23.1461 8.07532 23.324 8.1507 23.4881 8.23759C23.6812 7.00155 23.4865 6.15997 22.8209 5.3979C22.0871 4.55882 20.7627 4.19977 19.068 4.19977H14.1479C13.8017 4.19977 13.5064 4.45246 13.4529 4.79647L11.4037 17.8389C11.3633 18.0969 11.5615 18.3296 11.8206 18.3296H14.8581L16.441 8.25439Z"
      fill="#28356A"
    />
  </svg>
);

export const facebook = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 3H15C12.2386 3 10 5.23858 10 8V10H6V14H10V21H14V14H18V10H14V8C14 7.44772 14.4477 7 15 7H18V3Z"
      fill="#1A1818"
    />
  </svg>
);

export const instagram = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="4"
      stroke="#1A1818"
      strokeWidth="1.5"
    />
    <circle cx="18" cy="6" r="1" fill="#1A1818" />
    <circle cx="12" cy="12" r="5" stroke="#1A1818" strokeWidth="1.5" />
  </svg>
);

export const twitter = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2863 4C13.1825 4 11.477 5.79086 11.477 8C11.477 8.33382 11.5159 8.65809 11.5893 8.96808C9.56635 8.96808 6.51939 8.55908 3.97468 6.00961C3.6363 5.67059 3.01233 5.89726 3.0358 6.37567C3.41293 14.0627 6.70501 16.3049 8.40034 16.4444C7.3056 17.5257 5.71534 18.3791 4.11513 18.7622C3.69281 18.8633 3.58848 19.3256 4.00144 19.4599C5.14647 19.8323 6.78541 19.9758 7.66759 20C13.9084 20 18.9809 14.7471 19.0938 8.22229C19.9131 7.68945 20.438 6.5325 20.7329 5.71291C20.8047 5.5133 20.4775 5.28073 20.2817 5.36226C19.6696 5.61708 18.8926 5.67749 18.2306 5.46181C17.532 4.56927 16.4725 4 15.2863 4Z"
      fill="#1A1818"
    />
  </svg>
);
